/* eslint-disable */

const mobilePosition = {
  name: "mobilePosition",
  enabled: true,
  phase: "beforeWrite",
  requires: ["computeStyles"],
  fn(_ref) {
    let {
      state
    } = _ref;
    state.styles.popper.transform = "unset";
    state.styles.popper.right = "0";
    state.styles.popper.bottom = "0";
    state.styles.popper.position = "fixed";
  }
};

export { mobilePosition };
